import { render, staticRenderFns } from "./RideCard.vue?vue&type=template&id=3240a485&scoped=true&"
import script from "./RideCard.vue?vue&type=script&lang=js&"
export * from "./RideCard.vue?vue&type=script&lang=js&"
import style0 from "./RideCard.vue?vue&type=style&index=0&id=3240a485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3240a485",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout})
